import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import buttonStyles from "~/styles/buttonStyles";

import { buttonColorOptions, buttonColorDefault } from "~/constants/buttons";

const StyledButton = styled.button`
    ${buttonStyles};
`;

const Button = ({
    active = false,
    children,
    className,
    backgroundColor = buttonColorDefault,
    onClick,
}) => (
    <StyledButton
        {...{ active, className, backgroundColor, onClick }}
        type="button"
    >
        {children}
    </StyledButton>
);

Button.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    backgroundColor: PropTypes.oneOf(buttonColorOptions),
    onClick: PropTypes.func.isRequired,
};

export default Button;
